export enum INLINE_MESSAGE_VARIANTS {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ALERT = 'alert',
  BLANK = '',
}
